import { Store_item } from './store_item';
import { Additional_field } from '../../additional_field';

export class Store_category {

	horse_show_id: string;
	number: number;
	description: string;
	additional_fields: Additional_field[] = [];
	name: string;
	refund_policy: string;
	merchant_details: string;
	
	store_category_items: Store_item[] = [];
	
	constructor(values: Object = {}) {
		Object.assign(this, values);
	}
	

}